import React, { useContext, useState, useEffect } from "react";

const AuthContext = React.createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [loading, setLoading] = useState(true);
  const [isValidSession, setIsValidSession] = useState(false);
  const [accessToken, setAccessToken] = useState(null);
  const [msisdn, setMsisdn] = useState(null);

  //const url = "http://localhost:9998";

  //const url = "http://localhost:9998";
  const url = 'https://wellness-backend-7e2gn.ondigitalocean.app';

  const port = process.env.PORT || 8080;

  useEffect(() => {
    const extractAndStoreAccess = () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const accessParam = urlParams.get('access');
        
        /*
        console.log("Current URL:", window.location.href);
        console.log("Search params:", window.location.search);
        console.log("Access parameter from URL:", accessParam);
        */
       
        if (accessParam) {
          sessionStorage.setItem('encoded_access', accessParam);
          const decodedAccess = atob(accessParam);
          //console.log("Decoded access (base64):", decodedAccess);
          sessionStorage.setItem('msisdn', decodedAccess);
          setMsisdn(decodedAccess);
        } else {
          const storedMsisdn = sessionStorage.getItem('msisdn');
          //console.log("Retrieved msisdn from sessionStorage:", storedMsisdn);
          setMsisdn(storedMsisdn);
        }
      } catch (error) {
        console.error("Error extracting access from URL:", error);
        setMsisdn(null);
      }
    };

    extractAndStoreAccess();
  }, []);

  useEffect(() => {
    if (!msisdn) {
      // No msisdn means no access parameter - set loading to false and session invalid
      setLoading(false);
      setIsValidSession(false);
      return;
    }

    const validateWellnessSession = async () => {
      try {
        setLoading(true);
        //console.log("Validating wellness session for msisdn:", msisdn);

        const response = await fetch(`${url}/wellness/validate`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            msisdn: msisdn
          }),
        });

        const result = await response.json();
        //console.log("Wellness validation response:", result);

        if (result.success && result.data?.access_token) {
          setAccessToken(result.data.access_token);
          setIsValidSession(true);
          
          // Optionally store in sessionStorage for persistence
          sessionStorage.setItem('wellness_access_token', result.data.access_token);
          sessionStorage.setItem('wellness_session_valid', 'true');

          //console.log("✅ Wellness session validated successfully");
        } else {
          // Invalid session
          setIsValidSession(false);
          setAccessToken(null);
          
          // Clear any stored tokens
          sessionStorage.removeItem('wellness_access_token');
          sessionStorage.removeItem('wellness_session_valid');

          //console.log("❌ No valid wellness session found:", result.message);
        }
      } catch (error) {
        console.error("❌ Error validating wellness session:", error);
        setIsValidSession(false);
        setAccessToken(null);
      } finally {
        setLoading(false);
      }
    };

    validateWellnessSession();
  }, [msisdn, url]);

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${accessToken}`,
  };

  const logPageAccess = async (path) => {
    try {
      if (!accessToken) return; 
      
      await fetch(`${url}/wellness/log-access`, {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
          path: path,
        }),
      });
      
    } catch (error) {
      console.error("Error logging page access:", error);
    }
  };

  const value = {
    accessToken,
    headers,
    url,
    msisdn,
    loading,
    isValidSession,
    logPageAccess,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
